import CrudAPI from '@/api/resources/crud'
import store from '@/store'

const casesAPI = {
  // specific cases api
  resource: 'cases',
  url_query: '/api/cases',

  loadCase (id) {
    return new Promise((resolve, reject) => {
      let cases = CrudAPI.dfsResourceShow(this.resource, id)

      cases.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  sendQuotationMailToClient (caseId) {
    return new Promise((resolve, reject) => {
      let data = CrudAPI.dfsResourceStore(this.resource + '/' + caseId + '/client/quotation/email', {})

      data.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  markInvoiceAsPaid (caseId) {
    return new Promise((resolve, reject) => {
      let data = CrudAPI.dfsResourceStore(this.resource + '/' + caseId + '/invoice/mark-paid', {})

      data.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  attachServicesPlanCasketToCase (caseId, selectedProducts, discount = null, selectedPlan = null, tagAndRemarks = null, wakeDateStart, wakeDateEnd) {
    let promises = []

    return new Promise((resolve, reject) => {
      let selectedServicesIds = selectedProducts.map(mapping => {
        return {
          service_id: mapping.id,
          amount: mapping.amount
        }
      })

      let payload = {
        plans_id: selectedPlan.id,
        embalmers_remarks: tagAndRemarks,
        wake_start: wakeDateStart,
        wake_end: wakeDateEnd,
        services: selectedServicesIds,
        discount: discount
      }

      this.updateCase(caseId, payload).then(() => {
        resolve(promises)
      }, error => { reject(error) })
    })
  },

  attachVendorServicesToCase (caseId, selectedProducts) {
    let promises = []

    return new Promise((resolve, reject) => {
      let selectedServicesIds = selectedProducts.map(mapping => {
        return {
          service_id: mapping.id,
          amount: mapping.amount
        }
      })

      this.updateCase(caseId, {
        services: selectedServicesIds
      }).then(() => {
        resolve(promises)
      }, error => { reject(error) })
    })
  },

  attachUserToCase (caseId, userId) {
    return new Promise(resolve => {
      let payload = {
        users_id: userId
      }

      CrudAPI.dfsResourceUpdate(this.resource, caseId, payload).then(result => {
        resolve(result)
      })
    })
  },

  uploadPhotoForEmbalmers (caseId, data) {
    let url = store.getters.config.api_host + '/api/cases/' + caseId + '/embalmers-photo'

    let config = {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    }

    return new Promise((resolve, reject) => {
      store.getters.axios.post(url, data, config).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },

  attachChatToCase (caseId, chatId) {
    return new Promise((resolve, reject) => {
      let payload = {
        chats_id: chatId
      }

      CrudAPI.dfsResourceUpdate(this.resource, caseId, payload).then(result => {
        resolve(result)
      })
    })
  },

  attachDefaultChecklistToCase (caseId, serviceId) {
    return new Promise((resolve, reject) => {
      let payload = {
        services_id: serviceId
      }

      CrudAPI.dfsResourceStore(this.resource + '/' + caseId + '/checklist', payload).then(result => {
        resolve(result)
      })
    })
  },

  attachPlanToCase (caseId, planId) {
    return new Promise((resolve, reject) => {
      let payload = {
        plans_id: planId
      }

      CrudAPI.dfsResourceUpdate(this.resource, caseId, payload).then(result => {
        resolve(result)
      })
    })
  },

  attachClientToCase (caseId, clientId) {
    return new Promise((resolve, reject) => {
      let payload = {
        clients_id: clientId
      }

      CrudAPI.dfsResourceUpdate(this.resource, caseId, payload).then(result => {
        resolve(result)
      })
    })
  },

  attachInventoriesToCase (caseId, inventories) {
    return new Promise((resolve, reject) => {
      let payload = {
        inventories: inventories
      }

      CrudAPI.dfsResourceUpdate(this.resource, caseId, payload).then(result => {
        resolve(result)
      })
    })
  },

  attachServicesToCase (caseId, services, discount) {
    return new Promise((resolve, reject) => {
      let payload = {
        services: services,
        discount: discount
      }

      CrudAPI.dfsResourceUpdate(this.resource, caseId, payload).then(result => {
        resolve(result)
      })
    })
  },

  getLinkedInvoices (caseId) {
    let url = store.getters.config.api_host + this.url_query + '/' + caseId + '/invoices'

    return new Promise((resolve, reject) => {
      store.getters.axios.get(url).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },

  getQuotationTotalPrice (caseId) {
    let url = store.getters.config.api_host + this.url_query + '/' + caseId + '/quotation'

    return new Promise((resolve, reject) => {
      store.getters.axios.get(url).then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  getLinkedAnswers (caseId) {
    let url = store.getters.config.api_host + this.url_query + '/' + caseId + '/answers'

    return new Promise((resolve, reject) => {
      store.getters.axios.get(url).then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  getLinkedChat (caseId) {
    let url = store.getters.config.api_host + this.url_query + '/' + caseId + '/chat'

    return new Promise((resolve, reject) => {
      store.getters.axios.get(url).then(response => {
        resolve(response !== undefined ? response.data.additional_data[0] : reject())
      }, error => {
        reject(error)
      })
    })
  },

  loadPDF (answersId) {
    return new Promise((resolve, reject) => {
      let pdf = CrudAPI.dfsResourceShow('pdf', answersId)

      pdf.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  loadPDFFeedback (answersId) {
    return new Promise((resolve, reject) => {
      let pdf = CrudAPI.dfsResourceShow('pdf/feedback', answersId)

      pdf.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  loadPDFAgreement (answersId) {
    return new Promise((resolve, reject) => {
      let pdf = CrudAPI.dfsResourceShow('pdf/agreement', answersId)

      pdf.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  loadCases () {
    return new Promise((resolve, reject) => {
      let cases = CrudAPI.dfsResourceIndex(this.resource)

      cases.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  loadCasesWithEmbalming () {
    return new Promise((resolve, reject) => {
      let cases = CrudAPI.dfsResourceIndex(this.resource + '/embalming')

      cases.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  loadLogForCase (itemId) {
    let url = store.getters.config.api_host + this.url_query + '/' + itemId + '/actions'

    return new Promise((resolve, reject) => {
      store.getters.axios.get(url).then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  loadCaseManager (itemId) {
    let url = store.getters.config.api_host + this.url_query + '/' + itemId + '/casemanager'

    return new Promise((resolve, reject) => {
      store.getters.axios.get(url).then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  updateCaseManager (caseId, managerId) {
    let url = store.getters.config.api_host + this.url_query + '/' + caseId + '/casemanager/' + managerId

    return new Promise((resolve, reject) => {
      store.getters.axios.post(url).then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  changeCaseManagerCommissions (caseId, payload) {
    let url = store.getters.config.api_host + this.url_query + '/' + caseId + '/casemanager-commissions'

    return new Promise((resolve, reject) => {
      store.getters.axios.post(url, payload).then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  closeCase (itemId) {
    return new Promise((resolve, reject) => {
      let payload = {
        status: 'closed'
      }

      let cases = CrudAPI.dfsResourceUpdate(this.resource, itemId, payload)

      cases.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  approveCase (itemId) {
    return new Promise((resolve, reject) => {
      let payload = {
        status: 'approved'
      }

      let cases = CrudAPI.dfsResourceUpdate(this.resource, itemId, payload)

      cases.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  loadActiveCases () {
    return new Promise((resolve, reject) => {
      let cases = CrudAPI.dfsResourceIndex(this.resource)

      cases.then(result => {
        result.forEach((item, i) => {
          item.text = item.id
          item.value = item.id
        })

        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  getLinkedServices (itemId) {
    let url = store.getters.config.api_host + this.url_query + '/' + itemId + '/services'

    return new Promise((resolve, reject) => {
      store.getters.axios.get(url).then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  getLinkedVendors (itemId) {
    let url = store.getters.config.api_host + this.url_query + '/' + itemId + '/vendors'

    return new Promise((resolve, reject) => {
      store.getters.axios.get(url).then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  getVendorProducts (itemId, userId) {
    let url = store.getters.config.api_host + this.url_query + '/' + itemId + '/vendors/' + userId + '/products'

    return new Promise((resolve, reject) => {
      store.getters.axios.get(url).then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  getLinkedInventories (itemId) {
    let url = store.getters.config.api_host + this.url_query + '/' + itemId + '/inventories'

    return new Promise((resolve, reject) => {
      store.getters.axios.get(url).then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  getCaseItems (caseId) {
    return new Promise((resolve, reject) => {
      let items = CrudAPI.dfsResourceIndex(this.resource + '/' + caseId + '/items')

      items.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  getLead (caseId) {
    return new Promise((resolve, reject) => {
      let items = CrudAPI.dfsResourceIndex(this.resource + '/' + caseId + '/lead')

      items.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  saveCase ({ name }) {
    return new Promise((resolve, reject) => {
      let payload = {
        name: name
      }

      let schedules = CrudAPI.dfsResourceStore(this.resource + '/withid', payload)

      schedules.then(result => {
        resolve(result.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  updateCase (caseId, payload) {
    return new Promise((resolve, reject) => {
      let caseUpdate = CrudAPI.dfsResourceUpdate(this.resource, caseId, payload)

      caseUpdate.then(result => {
        resolve(result)
      })
    })
  }
}

export default casesAPI



// WEBPACK FOOTER //
// ./src/api/resources/cases.js